module.exports = __webpack_public_path__ + "assets/img/rank0.26a21e74.png";